<script setup>
import { defineProps } from 'vue'

import styles from './AttendanceMark.module.css'

const props = defineProps({
  pending: Boolean,
  confirmed: Boolean,
  unpaid: Boolean
})
</script>

<template>
  <div
    :class="[
      styles.attendance,
      {[styles.pending]: props.pending},
      {[styles.confirmed]: props.confirmed},
      {[styles.unpaid]: props.unpaid},
      'inline'
    ]"
  ></div>
</template>

<style scoped>
.inline {
  display: inline-block;
  width: 1em;
  height: 1em;
  border-radius: 9999px;
  margin-bottom: -0.2em;
  margin-right: 0.3em;
}
</style>
